import { gql } from '@apollo/client';
export const CLIENT_CONFIG_FIELDS = gql `
  fragment ClientConfigFields on ClientConfig {
    id
    clientId
    locale
    currency
    timezone
    country
    createdAt
    updatedAt
    extraData
  }
`;
export const CLIENT_CONFIG = gql `
  ${CLIENT_CONFIG_FIELDS}
  query CLIENT_CONFIG($clientId: Int!) {
    clientConfig(clientId: $clientId) {
      ...ClientConfigFields
    }
  }
`;
export const SAVE_CLIENT_CONFIG = gql `
  ${CLIENT_CONFIG_FIELDS}
  mutation SAVE_CLIENT_CONFIG($input: ClientConfigInput!) {
    saveClientConfig(input: $input) {
      ...ClientConfigFields
    }
  }
`;
export const CURRENT_CLIENT_CONFIG = gql `
  ${CLIENT_CONFIG_FIELDS}
  query CURRENT_CLIENT_CONFIG {
    currentClientConfig {
      ...ClientConfigFields
    }
  }
`;
